import Header from '../__header/Header';
import Accordion from '../__shortcodes/accordions';
import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import forms from '../__utils/forms';
import vhUnit from '../__utils/vhUnit';
import AlertBar from '../__header/AlertBar';
import cookiesAlert from '../__utils/cookiesAlert';
import { ActivitySingleHeroSlider } from '../__utils/sliders';
import ImageHelper from '../__utils/ImageHelper';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector( 'html' ).classList.remove( 'no-js' );
		Header.init();
		smoothScroll();
		Accordion.init();
		Video.init();
		mirrorHover();
		Tables.init();
		vhUnit();
		AlertBar();
		cookiesAlert();
		ActivitySingleHeroSlider.init();
		ImageHelper();
	},
	loaded() {
		document.querySelector( 'body' ).classList.add( 'page-has-loaded' );
		vhUnit();
		Header.resizeMegaMenu();
	},
	resized() {
		Header.resized();
		Tables.toggleShadow();
		vhUnit();
	},
	scrolled() {},
	keyDown() {},
	mouseUp( e ) {
		Header.hideOutsideClick( e );
	},
	gformRender() {
		forms();
	},
};
export default controller;
